import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import SessionTypeForm from "./SessionTypeForm";
import { createSessionMaster } from "../../store/slices/sessionSlice";
import { fetchSessionCategories } from "../../store/slices/sessionCategorySlice";

const AddSessionType = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { sessionCategories } = useSelector((state) => state.sessionCategories);

    useEffect(() => {
        dispatch(fetchSessionCategories());
    }, [dispatch]);

    const [formData, setFormData] = useState({
        session_category_master_id: "",
        name: "",
        description: "",
        status: "active",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.session_category_master_id) newErrors.session_category_master_id = "Category is required";
        if (!formData.name.trim()) newErrors.name = "Name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            await dispatch(createSessionMaster(formData)).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Session Type added successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate("/session-types");
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err.message || "Failed to add Session Type",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <SessionTypeForm
                                formData={formData}
                                handleChange={handleChange}
                                categories={sessionCategories}
                            />

                            <div className="row mt-3">
                                <div className="col-md-2 ms-auto">
                                    <button type="submit" className="btn btn-primary w-100">
                                        <i className="ri-save-3-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddSessionType;
